import { MinimalVideoSkinElement } from '../../presets/video/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import './minimal-ui';

safeDefine(MinimalVideoSkinElement);
